export const gradientLineHeight = '8px';
export const gradientLineMarginBottom = '8px';

export const addColorByValueMarginTop = parseInt(gradientLineHeight) + parseInt(gradientLineMarginBottom) + 'px';
